import StudentsPage from "@/pages/students";
import PrivateLayout from "@/components/layouts/private-layout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/students/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <StudentsPage />
    </PrivateLayout>
  );
}
